import React from "react";
import { useLoading } from "../../../context/loadingContext";
import { Table, Tag } from "antd";
import { bankCodes } from "../../../constant/bankCode";

const BankCodeList = () => {
  const [data, setData] = React.useState(bankCodes);
  const { showLoading, hideLoading } = useLoading();

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 50,
      fixed: "left",
      render: (e, r, index) => index + 1,
    },
    {
      title: "Нэр",
      dataIndex: "bank_name",
      key: "bank_name",
      width: 150,
    },
    {
      title: "Код",
      dataIndex: "bank_code",
      key: "bank_code",
      width: 150,
    },
    {
      title: "БИК код",
      dataIndex: "BIC_code",
      key: "BIC_code",
      width: 100,
    },
  ];
  return (
    <div>
      <Table
        scroll={{ y: "80vh" }}
        dataSource={data}
        columns={columns}
        pagination={false}
        rowKey="id"
      />
    </div>
  );
};

export default BankCodeList;
